import React, { useState } from 'react';
import { Offcanvas, Tab } from 'react-bootstrap';
import { BasicInfo, GeneralInfo, Vehicle, DriverNotes, FraudCheck } from './components';
import NoDataBlock from 'components/common/NoDataBlock';
import TabWraper from 'components/pages/TabWrapper';
import { useDriversContext } from '../DriversContext';

export default function AddUpdateDriver({ show, onCloseModal, driverId, data = {} }) {
  const [activeTab, setActiveTab] = useState('general');
  // Only portal admin can read the fraud endpoints, so the tab is hidden rather
  // than shown empty for everyone else.
  const { canViewPaymentVelocity } = useDriversContext();

  const { status, id } = data;

  return (
    <>
      <Offcanvas
        show={show}
        placement={'end'}
        onHide={onCloseModal}
        backdropClassName="custom-drawer"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="d-flex align-items-center">
            <span className="me-1">{driverId ? 'Viewing Driver' : 'Creating Driver'}</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {driverId && <BasicInfo />}
          <TabWraper
            id="controlled-tab"
            activeKey={activeTab}
            onSelect={k => setActiveTab(k)}
            visibleItems={
              driverId
                ? [
                    'general',
                    'vehicle',
                    'note',
                    'history',
                    ...(canViewPaymentVelocity ? ['fraud'] : [])
                  ]
                : ['general']
            }
          >
            <Tab
              eventKey="general"
              title="General"
              tabClassName="fs-1"
              className="border-bottom border-x p-3"
            >
              <GeneralInfo />
            </Tab>
            {id && status === 1 && (
              <Tab
                eventKey="vehicle"
                title="Vehicle"
                tabClassName="fs-1"
                className="border-bottom border-x p-3"
              >
                <Vehicle id={data.id} />
              </Tab>
            )}
            <Tab
              eventKey="note"
              tabClassName="fs-1"
              title="Notes"
              className="border-bottom border-x p-3"
            >
              <DriverNotes />
            </Tab>
            <Tab
              eventKey="history"
              title="History"
              tabClassName="fs-1"
              className="border-bottom border-x p-3"
            >
              <NoDataBlock />
            </Tab>
            <Tab
              eventKey="fraud"
              title="Fraud Check"
              tabClassName="fs-1"
              className="border-bottom border-x p-3"
            >
              <FraudCheck />
            </Tab>
          </TabWraper>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
